import { BoxProps } from '@types'
import { motion } from 'framer-motion'
import styled from 'styled-components'

import Box from '../Box'

const BoxMotion = styled(motion.custom(Box))<BoxProps>``

export default BoxMotion
